import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { Component } from '@angular/core';
import { GridButtonMode } from './grid-button.interface';
import { DialogType } from '../../dialog/dialog.interface';

@Component({
  selector: 'grid-button-renderer',
  templateUrl: './grid-button.component.html',
  styleUrls: ['./grid-button.component.css']
})
export class GridButtonRendererComponent implements ICellRendererAngularComp {

  public mode: GridButtonMode = GridButtonMode.View;
  public type: DialogType;
  public visible: boolean = true;

  private fieldToEvaluate?: string;
  private params: any;
  private parent: any;

  public agInit(params: any): void {
    this.params = params;
    this.parent = params.context.componentParent;
    this.visible = params.visible;
    this.mode = params.mode || GridButtonMode.View;
    this.type = params.type;
    this.fieldToEvaluate = params.fieldToEvaluate;

    this.manageButtonMode(this.mode);
  }

  private manageButtonMode(buttonMode: GridButtonMode): void{
    if (buttonMode === GridButtonMode.Add)
        this.Add();
  }

  private Add(): void {
    const data = this.params?.data;
    if(data[this.fieldToEvaluate])
      this.mode = GridButtonMode.Edit;
  }

  public refresh(): boolean {
    return false;
  }

  public onClick(): void {
    this.params.mode = this.mode;
    this.params.type = this.type;
    this.parent.onGridbuttonCliked(this.params);
  }

}
